import { isNull } from "lodash";
import React from "react";
import { stringToFunctionConverter } from "../../utils";
import AddToolTip from "../AddToolTip";

const MapAndTransformOutputFixedWidthField = (props) => {
  const { value, fieldName, from, to, typeSetting } = props?.data || {};
  const { setFieldIndex, index, setShowSlideOut } = props;
  const idx = String(index + 1).padStart(2, "0");

  return (
    <div
      className="section-field-box m-3 p-3"
      style={{ cursor: "pointer" }}
      onClick={() => {
        if (setShowSlideOut) {
          setShowSlideOut(true);
          setFieldIndex(index);
        }
      }}
    >
      <div
        className="d-flex flex-column align-items-start justify-content-center"
        style={{ width: "40%" }}
      >
        <div className="section-field-header w-100">
          <AddToolTip
            name={
              !isNull(fieldName)
                ? `Field ${idx} | ${fieldName}`
                : `Field ${idx}`
            }
          />
        </div>
        <span className="d-flex section-field-value w-100">
          <span className="grey-text mr-1">Value:</span>
          <AddToolTip name={stringToFunctionConverter(value)} />
        </span>
      </div>
      <div
        className="d-flex flex-column align-items-center justify-content-center"
        style={{ width: "20%" }}
      >
        <div className="section-field-value">From</div>
        <div className="section-field-header fs-12">
          {from == null ? 0 : from?.toLocaleString()}
        </div>
      </div>
      <div
        className="d-flex flex-column align-items-center justify-content-center"
        style={{ width: "20%" }}
      >
        <div className="section-field-value">To</div>
        <div className="section-field-header fs-12">{to == null ? 0 : to}</div>
      </div>
      <div
        className="d-flex align-items-center justify-content-center"
        style={{ width: "20%" }}
      >
        {typeSetting == 3 && (
          <div className="section-indicator p-1">Indicator</div>
        )}
        {typeSetting == 1 && <div className="section-indicator p-1">Key</div>}
      </div>
    </div>
  );
};

export default MapAndTransformOutputFixedWidthField;
